export interface ClipboardWriter {
    writeText(text: string): Promise<void>;
}

// Matches what the browser renders: HTML collapses runs of whitespace into one space.
export function normalizeCopyText(text: string): string {
    return text.trim().replace(/\s+/g, ' ');
}

function defaultClipboard(): ClipboardWriter | undefined {
    if (typeof navigator === 'undefined' || !navigator.clipboard?.writeText) return undefined;
    return navigator.clipboard;
}

// Resolves false rather than rejecting: the API is missing outside secure contexts and
// writes reject when permission is denied, so callers choose their own feedback.
async function writeClipboard(
    text: string,
    clipboard: ClipboardWriter | undefined
): Promise<boolean> {
    if (!clipboard) return false;
    try {
        await clipboard.writeText(text);
        return true;
    } catch {
        return false;
    }
}

// Use for single-line values shown on screen (names, IDs); copyToClipboard keeps text as-is.
export async function copyTextToClipboard(
    text: string,
    clipboard: ClipboardWriter | undefined = defaultClipboard()
): Promise<boolean> {
    const value = normalizeCopyText(text);
    if (value === '') return false;
    return writeClipboard(value, clipboard);
}

// Use when line breaks and spacing must survive, e.g. multi-line reply text.
export async function copyToClipboard(
    text: string,
    clipboard: ClipboardWriter | undefined = defaultClipboard()
): Promise<boolean> {
    return writeClipboard(text, clipboard);
}
